import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../../shared/colors';

export const useStyles = makeStyles( theme => ({
    "btn-primary": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.dhcsBlue,
                "&:hover": {
                    color: colors.dhcsTealDark,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.dhcsBlue,
                '&:hover':{
                    backgroundColor: colors.dhcsTealDark,
                },
                '&:focus-visible': {
                    outline: `3px solid ${colors.dhcsBlue}`,
                    outlineOffset: '1px'
                  }
            }
        }
    },
    "btn-secondary": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.magellanDeepGreen,
                "&:hover": {
                    color: colors.magellanDeepGreen,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.magellanDeepGreen,
                '&:hover':{
                    backgroundColor: colors.magellanDeepGreen,
                },
                '&:focus-visible': {
                    outline: `3px solid ${colors.magellanDeepGreen}`,
                    outlineOffset: '1px'
                  }
            }
        }
    },
    "btn-danger": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.californiaRed,
                "&:hover": {
                    color: colors.californiaRed,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.magellanRed,
                '&:hover':{
                    backgroundColor: colors.magellanRed,
                },
                '&:focus-visible': {
                    outline: `3px solid ${colors.magellanRed}`,
                    outlineOffset: '1px'
                }
            }
        }
    },
    "btn-info": ({type}) => {
        if(type === 'icon-only'){
            return {
                color: colors.magellanDarkGray,
                "&:hover": {
                    color: colors.magellanDarkGray,
                }
            }
        }
        else if( type === 'icon-button') {
            return {
                backgroundColor: colors.magellanLightGray,
                color: colors.magellanBlack,
                '&:hover':{
                    backgroundColor: colors.magellanLightGray,
                    color: colors.magellanBlack
                },
                '&:focus-visible': {
                    outline: `3px solid ${colors.magellanLightGray}`,
                    outlineOffset: '1px'
                }
            }
        }
    },
    "btn-cancel": ({type}) => {
        if(type === 'icon-only'){
            return {
            }
        }
        else if( type === 'icon-button') {
            return {
                '&:focus-visible': {
                    outline: `3px solid ${colors.dhcsBlue}`,
                    outlineOffset: '1px'
                }
            }
        }
    }
}));
